import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { lessonsAPI } from '../../services/api';
import './StudentPages.css';

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLevel, setSelectedLevel] = useState('all');

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await lessonsAPI.getCourses();
      setCourses(response.data.courses);
    } catch (error) {
      console.error('Courses fetch error:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredCourses = selectedLevel === 'all' 
    ? courses 
    : courses.filter(c => c.level === selectedLevel);

  const levels = ['all', 'N5', 'N4', 'N3', 'N2', 'N1'];

  if (loading) {
    return (
      <div className="flex-center" style={{ height: '50vh' }}>
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <div className="courses-page fade-in">
      <h1>📚 Available Courses</h1>
      <p className="page-subtitle">Choose the course that matches your learning goals.</p>

      {/* レベルフィルター */}
      <div className="filter-bar" style={{ marginBottom: '24px' }}>
        <div className="filter-buttons">
          {levels.map((level) => (
            <button
              key={level}
              className={`btn ${selectedLevel === level ? 'btn-primary' : 'btn-outline'} btn-sm`}
              onClick={() => setSelectedLevel(level)}
            >
              {level === 'all' ? 'All Levels' : level}
            </button>
          ))}
        </div>
      </div>

      {/* コースグリッド */}
      <div className="courses-grid">
        {filteredCourses.map((course) => (
          <div key={course.id} className="course-card">
            <div className="course-header">
              <span className={`level-badge level-${course.level?.toLowerCase()}`}>
                {course.level}
              </span>
              <h3>{course.title}</h3>
              <p>{course.title_japanese}</p>
            </div>
            <div className="course-body">
              <p className="course-description">{course.description}</p>
              <div className="course-meta">
                <span>📖 {course.total_lessons || 0} Lessons</span>
                <span>🏷️ {course.category}</span>
              </div>
              <Link to={`/student/lessons/${course.id}`} className="btn btn-primary">
                Start Learning
              </Link>
            </div>
          </div>
        ))}
      </div>

      {filteredCourses.length === 0 && (
        <div className="empty-state">
          <p>No courses available for this level yet.</p>
          <p className="text-muted">Please choose another level.</p>
        </div>
      )}
    </div>
  );
};

export default Courses;
